import { useState, useEffect } from "react";
import moment from "moment";
import useInputState from "../../hooks/useInputState";

export const useOpportunityForm = () => {
  const initialState = {
    amount: "",
    isPercentage: false,
    visibility: false,
    expiresAt: moment()
      .add(1, "year")
      .format("YYYY-MM-DD"),
    formHasAnInvalidField: false
  };

  const [amount, onAmountChange] = useInputState(initialState.amount);
  const [visibility, setVisibility] = useState(initialState.visibility);
  const onToggleVisibility = () => setVisibility(!visibility);
  const [isPercentage, setIsPercentage] = useState(initialState.isPercentage);
  const onToggleIsPercentage = () => setIsPercentage(!isPercentage);
  const [selectedProduct, setSelectedProduct] = useInputState();
  const [expiresAt, setExpiresAt] = useState(initialState.expiresAt);
  const onExpiresAtChange = (date) => {
    return setExpiresAt(date && moment(date).format("YYYY-MM-DD"));
  };
  const [formHasAnInvalidField, setFormHasAnInvalidFields] = useState(
    initialState.formHasAnInvalidField
  );

  useEffect(() => {
    setFormHasAnInvalidFields(!amount || !selectedProduct || !expiresAt);
  }, [amount, selectedProduct, expiresAt]);

  const resetForm = () => {
    setVisibility(initialState.visibility);
    setIsPercentage(initialState.isPercentage);
    setExpiresAt(initialState.expiresAt);
    onAmountChange(initialState.amount);
    setSelectedProduct();
  };

  return {
    amount,
    onAmountChange,
    visibility,
    onToggleVisibility,
    isPercentage,
    onToggleIsPercentage,
    selectedProduct,
    setSelectedProduct,
    formHasAnInvalidField,
    expiresAt,
    onExpiresAtChange,
    resetForm
  };
};
